import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import closeIcon from 'assets/images/close-icon.svg'

import Locale from './locale'
import Styles from './styles.scss'


export default function ModalContent({ children, handleClose }) {
  const { formatMessage } = useIntl()

  return (
    <div className={ Styles.root }>
      {
        renderCloseButton({
          formatMessage,
          handleClose,
        })
      }

      { children }
    </div>
  )
}

ModalContent.propTypes = {
  children: PropTypes.node.isRequired,

  handleClose: PropTypes.func,
}

function renderCloseButton({ formatMessage, handleClose }) {
  if ( !handleClose ) {
    return null
  }

  const ariaLabel = formatMessage(Locale.ariaLabel)

  const onClick = (e) => {
    e.stopPropagation()
    handleClose()
  }

  return (
    <button
      aria-label={ ariaLabel }
      className={ Styles.closeButton }
      onClick={ onClick }
      type="button"
    >
      <img
        alt=""
        aria-hidden="true"
        src={ closeIcon }
      />
    </button>
  )
}
